import { render, staticRenderFns } from "./studentscore.vue?vue&type=template&id=408fcdae&scoped=true"
import script from "./studentscore.vue?vue&type=script&lang=js"
export * from "./studentscore.vue?vue&type=script&lang=js"
import style0 from "./studentscore.vue?vue&type=style&index=0&id=408fcdae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fcdae",
  null
  
)

export default component.exports